export default __webpack_public_path__ + "static/media/O-152.d8bb6b9f.png";